import { alpha } from '@mui/material';
import { getRGBA } from '../../utils/getRGBA/getRGBA.js';

function getSizeStyles(theme, $size) {
    switch ($size) {
        case "sm":
            return {
                minHeight: 24,
                fontSize: 12,
                lineHeight: "16px",
                letterSpacing: 1,
            };
        case "md":
            return {
                minHeight: 36,
                fontSize: 14,
                lineHeight: "20px",
                padding: theme.spacing(0, 1),
            };
        case "lg":
            return {
                minHeight: 44,
                fontSize: 16,
                lineHeight: "20px",
                padding: theme.spacing(0, 2),
            };
        case "xl":
            return {
                minHeight: 44,
                fontSize: 18,
                lineHeight: "20px",
                padding: theme.spacing(0, 2),
            };
        default:
            return {};
    }
}
function getVariantStyles(theme, variant, color) {
    switch (variant) {
        case "default":
            return getDefaultVariantButton(theme, color);
        case "outlined":
            return getOutlinedVariantButton(theme, color);
        case "ghost":
            return getGhostVariantButton(theme, color);
        default:
            return {};
    }
}
function getDefaultVariantButton(theme, color) {
    switch (color) {
        case "primary":
            return {
                backgroundColor: theme.palette.primary[800],
                color: theme.palette.text.white,
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${getRGBA(theme.palette.primary.main, 0.25)},
              0px 2px 8px 0px rgba(32, 37, 43, 0.1)
            `,
                },
                "&:active": {
                    backgroundColor: theme.palette.primary[800],
                    boxShadow: `
              0px -1px 2px 0px rgba(32, 37, 43, 0.1) inset,
              0px 2px 4px 0px rgba(32, 37, 43, 0.1) inset
            `,
                },
            };
        case "secondary":
            return {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.secondary,
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${getRGBA(theme.palette.ui50, 0.25)},
              0px 2px 8px 0px rgba(32, 37, 43, 0.1)
            `,
                },
                "&:active": {
                    backgroundColor: theme.palette.ui55,
                    boxShadow: `
              0px -1px 2px 0px rgba(32, 37, 43, 0.1) inset,
              0px 2px 4px 0px rgba(32, 37, 43, 0.1) inset
            `,
                },
            };
        case "error":
            return {
                backgroundColor: theme.palette.failure[700],
                color: theme.palette.text.white,
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${getRGBA(theme.palette.failure.main, 0.25)},
              0px 2px 8px 0px rgba(32, 37, 43, 0.1)
            `,
                },
                "&:active": {
                    backgroundColor: theme.palette.failure[700],
                    boxShadow: `
              0px -1px 2px 0px rgba(32, 37, 43, 0.1) inset,
              0px 2px 4px 0px rgba(32, 37, 43, 0.1) inset
            `,
                },
            };
        default:
            return {};
    }
}
function getOutlinedVariantButton(theme, color) {
    switch (color) {
        case "primary":
            return {
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.primary[800]}`,
                color: theme.palette.primary[800],
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${getRGBA(theme.palette.primary.main, 0.25)},
              0px 2px 8px 0px rgba(32, 37, 43, 0.1)
            `,
                },
                "&:active": {
                    boxShadow: `
              0px -1px 2px 0px rgba(32, 37, 43, 0.1) inset,
              0px 2px 4px 0px rgba(32, 37, 43, 0.1) inset
            `,
                },
            };
        case "secondary":
            return {
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.ui50}`,
                color: theme.palette.text.primary,
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${getRGBA(theme.palette.ui50, 0.25)},
              0px 2px 8px 0px rgba(32, 37, 43, 0.1)
            `,
                },
                "&:active": {
                    boxShadow: `
              0px -1px 2px 0px rgba(32, 37, 43, 0.1) inset,
              0px 2px 4px 0px rgba(32, 37, 43, 0.1) inset
            `,
                },
            };
        case "error":
            return {
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.failure[700]}`,
                color: theme.palette.failure[700],
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${getRGBA(theme.palette.failure.main, 0.25)},
              0px 2px 8px 0px rgba(32, 37, 43, 0.1)
            `,
                },
                "&:active": {
                    boxShadow: `
              0px -1px 2px 0px ${getRGBA(theme.palette.failure.main, 0.25)} inset,
              0px 2px 4px 0px ${getRGBA(theme.palette.failure.main, 0.25)} inset
            `,
                },
            };
        default:
            return {};
    }
}
function getGhostVariantButton(theme, color) {
    switch (color) {
        case "primary":
            return {
                color: theme.palette.primary.main,
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                border: 0,
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${getRGBA(theme.palette.text.highlight, 0.25)},
              0px 2px 8px 0px rgba(32, 37, 43, 0.1)
            `,
                },
                "&:active": {
                    boxShadow: `
              0px -1px 2px 0px rgba(32, 37, 43, 0.1) inset,
              0px 2px 4px 0px rgba(32, 37, 43, 0.1) inset
            `,
                },
            };
        case "secondary":
            return {
                color: theme.palette.text.secondary,
                backgroundColor: theme.palette.ui55,
                border: 0,
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${theme.palette.ui50},
              0px 2px 8px 0px #20252B1A
            `,
                },
                "&:active": {
                    boxShadow: `
              0px -1px 2px 0px #20252B1A inset,
              0px 2px 4px 0px #20252B1A inset
            `,
                },
            };
        case "error":
            return {
                color: theme.palette.failure[700],
                backgroundColor: alpha(theme.palette.failure[700], 0.1),
                border: 0,
                "&:hover": {
                    boxShadow: `
              0px 1px 2px 0px ${getRGBA(theme.palette.failure.main, 0.25)},
              0px 2px 8px 0px rgba(32, 37, 43, 0.1)
            `,
                },
                "&:active": {
                    boxShadow: `
              0px -1px 2px 0px ${getRGBA(theme.palette.failure.main, 0.1)} inset,
              0px 2px 4px 0px ${getRGBA(theme.palette.failure.main, 0.1)} inset
            `,
                },
            };
        default:
            return {};
    }
}

export { getSizeStyles, getVariantStyles };
//# sourceMappingURL=styles.js.map
